import React from "react";
import  { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { configData } from "../config";
import { Link } from '@mui/material';
import { Helmet } from 'react-helmet';
import './classes/ManageGlobalAmbassadors.css';
import Loading from './Loading';


 
const columns = [
  
  { field: 'U.username', headerName: 'Username',cellClassName:'user_name_column',headerClassName:'user_name_header', minWidth: 152,flex:1,renderCell: (params) => (
      <Link href={params.row.url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
        {params.row.username}
      </Link>
    )},
  { field: 'U.first_name', headerName: 'First Name',cellClassName:'first_name_column',headerClassName:'first_name_header',minWidth: 110,flex:1 },
  { field: 'U.last_name', headerName: 'Last Name',cellClassName:'last_name_column',headerClassName:'last_name_header',minWidth: 91,flex:1},
  { field: 'roles', headerName: 'Roles',sortable: false,cellClassName:'roles_column',headerClassName:'roles_header',minWidth: 230,flex:1},
  { field: 'U.status', headerName: 'Status',cellClassName:'status_active_column',headerClassName:'status_active_header',minWidth: 100,flex:1},
  { field: 'U.created_at', headerName: 'Created date',cellClassName:'created_column',headerClassName:'created_header',sortable: false,minWidth: 100,flex:1},
  { field: 'last_access', headerName: 'Last access',cellClassName:'last_access_column',headerClassName:'last_access_header',sortable: false,minWidth: 96,flex:1},
  {
    field: 'operations',
    headerName: 'Operations',
    cellClassName:'edit_column',headerClassName:'edit_header',
    minWidth: 120,
    flex:1,
    renderCell: (params) => (
      <Link href={params.row.edit_url} target="_blank" rel="noopener noreferrer"  style={{ color: "#2C99D2"}}>
        Edit
      </Link>
    ),
    sortable: false
  },
];

const ManageGlobalAmbassadors =() =>{

  const [rows, setRows] = React.useState([]);
  const [rowCount, setRowCount] = React.useState(0);
  const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
  const [sortModel, setSortModel] = React.useState([]);
  const [filterModel, setFilterModel] = React.useState({ items: [] });
  const [isLoading, setIsLoading] = useState(true);
const app_url = configData.APP_URL;
const [formData, setformData] = useState({
        field_first_name_value: '',
        field_last_name_value:'',
        name: ''      
    });
    const [appliedFormData, setAppliedFormData] = useState({
  field_first_name_value: '',
  field_last_name_value: '',
  name: ''
});

const handleChange = (event) => {
    const { name, value } = event.target;
    setformData({ ...formData, [name]: value });
    
  };
  React.useEffect(() => {
    const fetchData = async () => {
  
       try {
         setIsLoading(true);
      const response = await fetch(app_url+'user/getambassadorlist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          page: paginationModel.page,
          pageSize: paginationModel.pageSize,
          sortModel,
          filterModel,
          formData:appliedFormData,
        }),
      });
      const data = await response.json();
      console.log(data.data.rows);
      setRows(data.data.rows);
      setRowCount(data.data.totalRowCount); // Server should return totalRowCount
      }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
    };
    

    fetchData();
  }, [paginationModel, sortModel, filterModel,appliedFormData]); // Re-fetch data when these change


  /* Pagination, filter config ends here */

const handleSubmit = async (e) => {
  e.preventDefault();
   setPaginationModel({
                 page: 0,
                    pageSize: 50,
                 });
                  setAppliedFormData({ ...formData });
  try {
     setIsLoading(true);
const response = await fetch(app_url+'user/getambassadorlist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          page: 0,
          pageSize: 50,
          sortModel,
          filterModel,
          formData:formData
        }),
      });
      const data = await response.json();
      console.log(data.data.rows);
      setRows(data.data.rows);
      setRowCount(data.data.totalRowCount); // Server should return totalRowCount
      }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
  
}; 
 
    return(
        <>
         {isLoading ? (
              <Loading />
            ) : (
        <div id="main" className="manage-global-ambassador-main">
            <Helmet><title>Manage Global Ambassadors</title></Helmet>
           <div class="left"></div>
               
               <div class="center left-center">
                    <div className="manage_globalambassador-container">
                      <h1>Manage Global Ambassadors</h1>
                           <div className="manage_globalambassador-view-filters">
                            <form className="filters-form" onSubmit={handleSubmit}>
                                {/* First Name */}
                                <div className="filter-item">
                                <label htmlFor="edit-field-first-name-value">First Name</label>
                                <input
                                    type="text"
                                    id="edit-field-first-name-value"
                                    name="field_first_name_value"
                                    size="30"
                                    maxLength="128"
                                    value={formData.field_first_name_value}
                                    onChange={handleChange}
                                />
                                </div>

                                {/* Last Name */}
                                <div className="filter-item">
                                <label htmlFor="edit-field-last-name-value">Last Name</label>
                                <input
                                    type="text"
                                    id="edit-field-last-name-value"
                                    name="field_last_name_value"
                                    size="30"
                                    maxLength="128"
                                    value={formData.field_last_name_value}
                                    onChange={handleChange}
                                />
                                </div>

                                {/* Email */}
                                <div className="filter-item">
                                <label htmlFor="edit-mail">Username</label>
                                <input
                                    type="text"
                                    id="edit-mail"
                                    name="name"
                                    size="30"
                                    maxLength="128"
                                    value={formData.name}
                                    onChange={handleChange}
                                />
                                </div>

                                {/* Submit Button */}
                                <div className="">
                                <button className="form-submit" style={{marginLeft:"4px"}} type="submit">Apply</button>
                                </div>
                            </form>
                            </div>

                        <div className="manage_globalambassador-view-content">
                            <table className="manage_globalambassador-views-table">
                                   <div style={{ width: '100%' }}>
                                    <DataGrid
                                        rows={rows}
                                        columns={columns}
                                        rowCount={rowCount}
                                        paginationMode="server"
                                        sortingMode="server"
                                        filterMode="server"
                                        paginationModel={paginationModel}
                                        onPaginationModelChange={setPaginationModel}
                                        sortModel={sortModel}
                                        onSortModelChange={setSortModel}
                                        filterModel={filterModel}
                                        onFilterModelChange={setFilterModel}
                                        pageSizeOptions={[5, 10, 25,50]}
                                        getRowId={() => crypto.randomUUID()}
                                        getRowHeight={() => 'auto'}
                                        disableColumnFilter 
                                        disableColumnResize={true}
                                    />
    </div>
                            </table>
                        </div>

                   
                </div>
        </div>
        <div class="right">
          
        </div>
        </div>
        
     )}
    </>
  )
};

export default ManageGlobalAmbassadors;